// extracted by mini-css-extract-plugin
export default {"cont":"bucket_cont__6QM27","fixMargin":"bucket_fixMargin__T847p"};